class CommentsPagination extends HTMLElement {
  constructor() {
    super();
    this.btnWrapper = null;
    this.btnContent = null;
    this.urlLoadComments = null;
  }
  connectedCallback() {
    this.btnWrapper = this.querySelector(".btn-load-more");
    if (!this.btnWrapper) return;
    this.btnContent = this.btnWrapper.querySelector(".btn-custom-content");
    if (!this.btnContent) return;
    this.urlLoadComments = this.btnContent.dataset.nextUrl;
    this.btnContent.addEventListener("click", () => this.getMoreComments());
  }
  async getMoreComments() {
    var _a;
    try {
      this.btnContent.setAttribute("loading", "");
      this.btnContent.disabled = true;
      const response = await fetch(this.urlLoadComments);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const loadedComments = doc.querySelectorAll("comment-item");
      const commentsList = this.querySelector(".comments-list-body");
      loadedComments.forEach((comment) => {
        commentsList.appendChild(comment);
      });
      const nextBtn = doc.querySelector(".btn-load-more .btn-custom-content");
      if (nextBtn) {
        this.urlLoadComments = nextBtn.dataset.nextUrl;
        this.btnContent.dataset.nextUrl = nextBtn.dataset.nextUrl;
        this.btnContent.removeAttribute("loading");
      } else {
        this.btnWrapper.remove();
        (_a = this.querySelector(".comments-content-inner-pagination")) == null ? void 0 : _a.classList.add("hide");
      }
    } catch (err) {
    }
    this.btnContent.removeAttribute("loading");
    this.btnContent.disabled = false;
  }
}
if (!customElements.get("comments-pagination")) {
  customElements.define("comments-pagination", CommentsPagination);
}
